/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Resettingpassword1Inputs */

const en_resettingpassword1 = /** @type {(inputs: Resettingpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resetting password...`)
};

const de_resettingpassword1 = /** @type {(inputs: Resettingpassword1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort wird zurückgesetzt…`)
};

/**
* | output |
* | --- |
* | "Resetting password..." |
*
* @param {Resettingpassword1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const resettingpassword1 = /** @type {((inputs?: Resettingpassword1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Resettingpassword1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_resettingpassword1(inputs)
	return de_resettingpassword1(inputs)
});
export { resettingpassword1 as "resettingPassword" }